import { render } from "./TgUserChangeRuleDescription.vue?vue&type=template&id=e701031e&ts=true"
import script from "./TgUserChangeRuleDescription.vue?vue&type=script&lang=ts"
export * from "./TgUserChangeRuleDescription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__